/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createHttpValidationProblemDetailsFromDiscriminatorValue, createIdentifyDynamicWatermarkResponseFromDiscriminatorValue, createIErrorFromDiscriminatorValue, serializeIdentifyDynamicWatermarkRequest, serializeIdentifyDynamicWatermarkResponse, type HttpValidationProblemDetails, type IdentifyDynamicWatermarkRequest, type IdentifyDynamicWatermarkResponse, type IError } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /jobs/dynamic-watermark/identify
 */
export interface IdentifyRequestBuilder extends BaseRequestBuilder<IdentifyRequestBuilder> {
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<IdentifyDynamicWatermarkResponse>}
     * @throws {HttpValidationProblemDetails} error when the service returns a 400 status code
     * @throws {IError} error when the service returns a 404 status code
     * @throws {IError} error when the service returns a 409 status code
     */
     post(body: IdentifyDynamicWatermarkRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<IdentifyDynamicWatermarkResponse | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: IdentifyDynamicWatermarkRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const IdentifyRequestBuilderUriTemplate = "{+baseurl}/jobs/dynamic-watermark/identify";
/**
 * Metadata for all the requests in the request builder.
 */
export const IdentifyRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: IdentifyRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createHttpValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createIdentifyDynamicWatermarkResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeIdentifyDynamicWatermarkRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
